const features = [
  {
    icon: "ri-customer-service-2-line",
    title: "Atendimento humano",
    desc: "Você não fica perdido em plataforma automática. Nossa equipe orienta do início ao fim pelo WhatsApp.",
  },
  {
    icon: "ri-video-chat-line",
    title: "100% online por videoconferência",
    desc: "Emissão e renovação feitas de qualquer lugar do Brasil, sem sair de casa ou do escritório.",
  },
  {
    icon: "ri-refresh-line",
    title: "Renovação facilitada por até 10 anos",
    desc: "Depois da primeira validação, suas próximas renovações são mais rápidas e simples.",
  },
  {
    icon: "ri-shield-check-line",
    title: "Emitido pela Soluti / ICP-Brasil",
    desc: "Certificados com validade jurídica, emitidos por uma Autoridade Certificadora de 1º nível.",
  },
  {
    icon: "ri-sparkling-line",
    title: "Processo simples e claro",
    desc: "Explicamos tudo sem burocracia e sem linguagem complicada. Você entende cada etapa.",
  },
  {
    icon: "ri-building-4-line",
    title: "Foco em empresas e contadores",
    desc: "Entendemos a urgência de quem precisa emitir nota fiscal e acessar sistemas sem parar.",
  },
];

export default function FeaturesSection() {
  return (
    <section id="diferenciais" className="relative py-20 md:py-24 bg-background-50">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="text-center max-w-2xl mx-auto">
          <div className="inline-flex items-center gap-2 rounded-full border border-accent-500/30 bg-accent-50 px-3 py-1 text-xs font-medium text-accent-600">
            <span className="h-1.5 w-1.5 rounded-full bg-accent-500" />
            Por que escolher a AVcertifica
          </div>
          <h2 className="mt-4 text-3xl md:text-4xl lg:text-5xl font-semibold text-foreground-950 font-heading">
            Emitir com a gente é <span className="text-accent-500">diferente</span>
          </h2>
          <p className="mt-4 text-foreground-600">
            Há mais de 4 anos ajudando pessoas e empresas de Blumenau/SC e de todo o Brasil.
          </p>
        </div>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {features.map((f) => (
            <div
              key={f.title}
              className="group h-full rounded-2xl bg-background-50 border border-secondary-200 p-6 hover:border-accent-400 hover:-translate-y-1 hover:shadow-lg hover:shadow-accent-500/5 transition-all"
            >
              <div className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-accent-100 text-accent-600 group-hover:bg-accent-500 group-hover:text-background-50 transition-colors">
                <i className={`${f.icon} text-lg`}></i>
              </div>
              <h3 className="mt-4 font-heading text-lg font-semibold text-foreground-950">{f.title}</h3>
              <p className="mt-2 text-sm text-foreground-600">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}